export default [
  'BOTLocation'
]

/*
Appears on:
location,
*/
